import { useMemo } from 'react';

export default function useCost(count: number, unitCost: number) {
  return useMemo(() => count * unitCost, [count, unitCost]);
}
